export function generateUniqueIdWithIdPrefix() {
    return 'id-' + crypto.randomUUID();
}